import {
  CUSTOMERX_CREDENTIAL,
  CUSTOMERX_ENDPOINT,
  CUSTOMERX_KEY,
} from "@commons/consts";

export const sendTracking = ({
  external_id_client,
  type_tracking,
  identifier,
  email,
  extraData = {},
}) => {
  const payload = {
    email,
    external_id_client,
    identifier,
    type_tracking,
    extraData,
  };

  return fetch(CUSTOMERX_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      credential: CUSTOMERX_CREDENTIAL,
      key: CUSTOMERX_KEY,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error('[CustomerX] Erro ao enviar evento:', error);
    });
};
